import React from 'react'

export default function WarehouseFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #vat-form-container {
          height: 100%;
          padding: 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        #vat-input-form {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        #vat-input-form label {
          text-align: center;
          margin-bottom: 10px;
        }

        #vat-input-form input {
          font-size: 1.5rem;
          padding: 7px;
          text-align: center;
        }

        .button-group-container {
          margin-top: 20px;
          display: flex;
          justify-content: center;
        }
      `}
      </style>
    </React.Fragment>
  )
}
